const UPDATE_LIST = '@@posts/UPDATE_LIST';

const UPDATE_PINNED = '@@posts/UPDATE_PINNED';

const UPDATE_SCHEDULE = '@@posts/UPDATE_SCHEDULE';

const UPDATE_DETAILS = '@@posts/UPDATE_DETAILS';

const CLEAR_LIST = '@@posts/CLEAR_LIST'

export default {
	UPDATE_LIST,
	UPDATE_PINNED,
	UPDATE_DETAILS,
	CLEAR_LIST,
	UPDATE_SCHEDULE
};
